import { createFetch, type FetchRequest, type FetchOptions } from 'ofetch'

export default defineNuxtPlugin(() => {
  /**
   * Create a new ofetch, passing in the version of fetch that is now the RUM instrumentationWrapper
   * put in place by the invocation of datadogRum.init in the 01.dd plugin.
   */
  function instrumentedFetch<
    T = unknown,
    R extends FetchRequest = FetchRequest,
    O extends FetchOptions = FetchOptions,
  >(request: R, opts: O) {
    return <Promise<T>>createFetch({ fetch })(request, {
      ...opts,
      signal: AbortSignal.timeout(5000),
    })
  }

  return {
    provide: {
      instrumentedFetch,
    },
  }
})
